function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

const settle = require('axios/lib/core/settle');

const buildURL = require('axios/lib/helpers/buildURL');

const buildFullPath = require('axios/lib/core/buildFullPath');

const {
  isUndefined
} = require('axios/lib/utils');

const createError = require('axios/lib/core/createError');

class FetchAdapterClass {
  constructor() {}
  /**
   * - Create a request object
   * - Get response body
   * - Check if timeout
   */


  async adapter(config) {
    const request = createRequest(config);
    const reqPromise = this.getResponse(request, config);
    const data = await reqPromise;
    return new Promise((resolve, reject) => {
      if (data instanceof Error) {
        reject(data);
      } else {
        // @ts-ignore
        Object.prototype.toString.call(config.settle) === '[object Function]' ? config.settle(resolve, reject, data) : settle(resolve, reject, data);
      }
    });
  }

  requestMethod(request, config) {
    return fetch(request);
  }

  axiosRespHook(response, config) {
    return response;
  }
  /**
   * Fetch API stage two is to get response body. This function tries to retrieve
   * response body based on response's type
   */


  async getResponse(request, config) {
    let stageOne;

    try {
      stageOne = await this.requestMethod(request, config);
      stageOne = stageOne.clone();
    } catch (e) {
      console.error(e);
      return createError('Network Error', config, 'ERR_NETWORK', request);
    }

    const axiosHeaders = {};
    stageOne.headers.forEach(function (value, key) {
      axiosHeaders[key] = value;
    });
    const response = {
      data: null,
      status: stageOne.status,
      statusText: stageOne.statusText,
      headers: axiosHeaders,
      // Make a copy of headers
      config: config,
      request
    };

    if (stageOne.status >= 200 && stageOne.status !== 204) {
      switch (config.responseType) {
        case 'arraybuffer':
          response.data = await stageOne.arrayBuffer();
          break;

        case 'blob':
          response.data = await stageOne.blob();
          break;

        case 'json':
          response.data = await stageOne.json();
          break;

        case 'formData':
          response.data = await stageOne.formData();
          break;

        default:
          response.data = await stageOne.text();
          break;
      }
    }

    return this.axiosRespHook(response, config);
  }

}
/**
 * This function will create a Request object based on configuration's axios
 */

function createRequest(config) {
  const headers = new Headers({ ...config.headers
  }); // HTTP basic authentication

  if (config.auth) {
    const username = config.auth.username || '';
    const password = config.auth.password ? decodeURI(encodeURIComponent(config.auth.password)) : '';
    headers.set('Authorization', `Basic ${btoa(username + ':' + password)}`);
  }

  const method = config.method.toUpperCase();
  const options = {
    headers: headers,
    method
  };

  if (method !== 'GET' && method !== 'HEAD') {
    options.body = config.data;
  }

  if (config.mode) {
    options.mode = config.mode;
  }

  if (config.cache) {
    options.cache = config.cache;
  }

  if (config.integrity) {
    options.integrity = config.integrity;
  }

  if (config.redirect) {
    options.redirect = config.redirect;
  }

  if (config.referrer) {
    options.referrer = config.referrer;
  }

  if (config.signal) {
    options.signal = config.signal;
  } // This config is similar to XHR’s withCredentials flag, but with three available values instead of two.
  // So if withCredentials is not set, default value 'same-origin' will be used


  if (!isUndefined(config.withCredentials)) {
    options.credentials = config.withCredentials ? 'include' : 'omit';
  }

  const fullPath = buildFullPath(config.baseURL, config.url);
  const url = buildURL(fullPath, config.params, config.paramsSerializer); // Expected browser to throw error if there is any wrong configuration value

  return new Request(url, options);
}

var version = "10.0.0";

let forceNetworkOnly = false;
let PersistentCacheStrategy;

(function (PersistentCacheStrategy) {
  PersistentCacheStrategy["CACHE_ONLY"] = "CACHE_ONLY";
  PersistentCacheStrategy["NETWORK_ONLY"] = "NETWORK_ONLY";
  PersistentCacheStrategy["CACHE_FIRST"] = "CACHE_FIRST";
  PersistentCacheStrategy["CACHE_FIRST_WITH_SILENT_UPDATE"] = "CACHE_FIRST_WITH_SILENT_UPDATE";
})(PersistentCacheStrategy || (PersistentCacheStrategy = {}));

class PermCacheFetchAdapter extends FetchAdapterClass {
  constructor(persistentCacheConfig) {
    super();
    this.persistentCacheConfig = persistentCacheConfig;

    _defineProperty(this, "cacheStorage", void 0);

    _defineProperty(this, "storagePrefix", void 0);

    this.storagePrefix = persistentCacheConfig.storagePrefix;

    if (!this.storagePrefix) {
      throw new Error('storagePrefix key is required');
    }
  }

  async getCacheStorageAsync() {
    if (this.cacheStorage) {
      return this.cacheStorage;
    }

    try {
      this.cacheStorage = await caches.open(this.storagePrefix); // Firefox隐身模式会报错
    } catch (e) {
      forceNetworkOnly = true; // 下次用network only

      throw e;
    }

    return this.cacheStorage;
  }

  static getRequestVaryHeaderKeys(request) {
    const varyHeader = request.headers.get('Vary');

    if (!varyHeader) {
      return [];
    }

    return varyHeader.split(',').map(s => s.trim()).filter(s => s);
  }

  static async matchCache(cacheStorage, request) {
    const cachedResponse = await cacheStorage.match(request, {
      ignoreVary: false,
      ignoreSearch: false,
      ignoreMethod: false
    });

    if (!cachedResponse) {
      return null;
    }

    const matched = PermCacheFetchAdapter.getRequestVaryHeaderKeys(request).every(headerKey => {
      return request.headers.get(headerKey) === cachedResponse.headers.get(`X-Pshttp-Cache-Vary-${headerKey}`);
    });

    if (!matched) {
      console.debug(`Cache is not match by Vary Headers, deleting:`, cachedResponse);
      await cacheStorage.delete(request);
    }

    return matched ? cachedResponse : null;
  }

  async requestMethod(request, config) {
    const self = this;

    async function getCacheResponse() {
      try {
        const cacheStorage = await self.getCacheStorageAsync();
        const cachedResponse = await PermCacheFetchAdapter.matchCache(cacheStorage, request);

        if (cachedResponse) {
          if (await self.persistentCacheConfig.detectCacheUsableHook(cachedResponse, request)) {
            console.log('Use cache: ', cachedResponse);
            return cachedResponse.clone();
          } else {
            console.debug(`[${self.storagePrefix}] Cache is not usable, deleting`);
            await cacheStorage.delete(request);
          }
        } else {
          await cacheStorage.delete(request);
        }
      } catch (e) {
        console.warn(e);
        return null;
      }
    }

    async function requestAndUpdateCache() {
      const response = await fetch(request);
      const cacheResponse = response.clone(); // 不新建会只克隆丢失附加头

      const _responseClone = new Response(cacheResponse.body, cacheResponse); // 根据Vary header存储到response里， 以验证缓存是否匹配


      PermCacheFetchAdapter.getRequestVaryHeaderKeys(request).forEach(headerKey => {
        const reqValue = request.headers.get(headerKey);

        if (reqValue) {
          _responseClone.headers.append(`X-Pshttp-Cache-Vary-${headerKey}`, reqValue);
        }
      });

      if (await self.persistentCacheConfig.detectAllowCachingHook(_responseClone)) {
        try {
          const cacheStorage = await self.getCacheStorageAsync();
          await cacheStorage.put(request, _responseClone);
          console.debug(`[${self.storagePrefix}] Cache is updated:`, _responseClone);
        } catch (e) {
          console.warn(e);
        }
      }

      return response;
    }

    switch (this.persistentCacheConfig.strategy) {
      case PersistentCacheStrategy.CACHE_ONLY:
        {
          const cachedResponse = await getCacheResponse();
          return cachedResponse || new Response('psHttp Cache not hit', {
            status: 404
          });
        }

      case PersistentCacheStrategy.NETWORK_ONLY:
        {
          return fetch(request);
        }

      case PersistentCacheStrategy.CACHE_FIRST:
        {
          const cachedResponse = await getCacheResponse();

          if (cachedResponse) {
            return cachedResponse;
          }

          return requestAndUpdateCache();
        }

      case PersistentCacheStrategy.CACHE_FIRST_WITH_SILENT_UPDATE:
        {
          const cachedResponse = await getCacheResponse();

          if (cachedResponse) {
            // 故意不await
            requestAndUpdateCache().then(newResp => self.persistentCacheConfig.afterSilentCacheUpdateCompareHook(newResp, cachedResponse));
            return cachedResponse;
          }

          return requestAndUpdateCache();
        }
    }
  }

}

class PersistentCacheConfig {
  constructor(config) {
    _defineProperty(this, "storagePrefix", void 0);

    _defineProperty(this, "strategy", void 0);

    _defineProperty(this, "detectAllowCachingHook", void 0);

    _defineProperty(this, "detectCacheUsableHook", void 0);

    _defineProperty(this, "afterSilentCacheUpdateCompareHook", void 0);

    _defineProperty(this, "debug", window.location.search.includes('noraven'));

    _defineProperty(this, "VaryHeadersArray", ['Accept-Language', 'Authorization', 'x-api-version']);

    this.storagePrefix = config.storagePrefix || `pshttp-cache@${version}`;
    this.strategy = config.strategy || PersistentCacheStrategy.CACHE_FIRST;

    if (this.debug || !('caches' in window)) {
      this.strategy = PersistentCacheStrategy.NETWORK_ONLY;
    }

    function passOk(res) {
      return res.ok;
    }

    this.detectCacheUsableHook = config.detectCacheUsableHook ? (res, historicalRequest) => config.detectCacheUsableHook(res.clone(), historicalRequest) : passOk;
    this.detectAllowCachingHook = config.detectAllowCachingHook ? res => config.detectAllowCachingHook(res.clone()) : passOk;

    if (config.afterSilentCacheUpdateCompareHook) {
      this.afterSilentCacheUpdateCompareHook = (newResponse, historicalResponse) => config.afterSilentCacheUpdateCompareHook(newResponse.clone(), historicalResponse.clone());
    } else {
      this.afterSilentCacheUpdateCompareHook = (newResponse, historicalResponse) => undefined;
    }

    if (Array.isArray(config.VaryHeadersArray)) {
      this.VaryHeadersArray = config.VaryHeadersArray;
    }
  }

}

_defineProperty(PersistentCacheConfig, "defaults", {
  detectAllowCachingHook_statusdata(resp) {
    if (!resp.ok) {
      return Promise.resolve(false);
    } // 返回内容是status + data的模式的话，强烈建议要有这句！！


    return resp.json().then(body => {
      return body.status && body.data;
    }).catch(err => false);
  }

});

const isCacheStorageSupported = 'fetch' in window && 'caches' in window && 'CacheStorage' in window && 'match' in window.CacheStorage.prototype;
function requestConfigWrapper(config, persistentCacheConfig) {
  if (!isCacheStorageSupported) {
    console.warn('CacheStorage is not supported, fallback to network only');
    return config;
  }

  if (forceNetworkOnly) {
    return config;
  }

  const _conf = { ...config
  };
  const originHeaders = { ...(config.headers || {})
  };
  _conf.headers = { ...originHeaders,
    Vary: originHeaders.Vary || originHeaders.vary || persistentCacheConfig.VaryHeadersArray.join(',')
  };

  if (config.timeout) {
    console.warn('[FetchAdapter] timeout is not supported yet');
  }

  delete _conf.timeout;
  delete _conf.cache;

  const _adapterInst = new PermCacheFetchAdapter(persistentCacheConfig);

  return { ..._conf,
    adapter: _adapterInst.adapter.bind(_adapterInst),
    cache: 'no-cache'
  };
}

export { PersistentCacheConfig, PersistentCacheStrategy, requestConfigWrapper };
//# sourceMappingURL=PersistentCache.js.map
